<!--
 * @Description: 新客评审 - 编辑页面
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <DetailForm
          ref="detailFormRef"
          type="edit"
          isEdit
          v-model:value="dataForm"
          :clueTypeDisabled="clueTypeDisabled"
          :resetValue="initForm"
      />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { ref, reactive, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import DetailForm from './components/DetailForm.vue'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import { newClientEvaluationDetail } from '@/api/overseasSales/newClientEvaluation'
const route = useRoute()

const initForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: {
    demandInfo: { warehouses: [{}] },
    saleInfo: [{}],
    quotationInfo: { details: [{}] },
    contractInfo: { fixedCredit: {}, registrationFee: {}, monthlyMaintenanceFee: {} }
  },
  visitAddress: [{}]
})

const dataForm = reactive<FbuSalesClueEditParams.RootObject>(cloneDeep(initForm))
const clueTypeDisabled = ref(false)

onBeforeMount(() => {
  let fetchId = -1
  /// 这里判断两次一种是草稿id一种是流程id
  if (route.query.newClientId) {
    fetchId = route.query.newClientId as unknown as number
  } else if (route.query.draftId) {
    fetchId = route.query.draftId as unknown as number
  }
  newClientEvaluationDetail({ id: fetchId }).then((res) => {
    if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
      res.data.business.businessTypeSelect = res.data.business.businessType[0]
    }
    Object.assign(initForm, res.data)
    Object.assign(dataForm, res.data)
  })
})
</script>
<script lang="ts">
export default { name: 'DcCosOFbuNewClientEvaluationEdit' }
</script>

<style scoped></style>
